import { PageHero } from "@/components/common/PageHero";
import { FaqAccordion } from "@/components/common/FaqAccordion";
import { ClosingCTA } from "@/components/common/ClosingCTA";
import { LEGAL, FAQS } from "@/constants";
import { Seo } from "@/components/common/Seo";
import SEO from "@/components/SEO";
import { useExamFee } from "@/context/ExamFeeContext";

export default function FAQsPage() {
  const { examFee, loading: examFeeLoading } = useExamFee();

  const faqItems = FAQS.map((item) => {
    if (item.q === "What is the examination fee?") {
      return {
        ...item,
        a:
          examFeeLoading || examFee === null
            ? "The examination fee is payable at the time of application. See the Examination Fee section for details."
            : `₹${examFee}, payable at the time of application. See the Examination Fee section for details.`,
      };
    }

    return item;
  });

  const feeText =
    examFeeLoading || examFee === null
      ? "examination"
      : `₹${examFee}`;

  return (
    <>
      <SEO page="faqs" />

      <div data-testid="faqs-page">
        <Seo
          title="FAQs"
          path="/faqs"
          description={`Answers to common questions about CET 2027 — eligibility, ${feeText} fee, exam pattern, key dates, selection of the top 1,000 and top 20, and the Dubai Global Experience.`}
        />

        <PageHero
          title="Frequently Asked Questions"
          subtitle="Everything you need to know about CET 2027 — eligibility, fees, dates, results, and the Dubai Global Experience."
        />

        <section className="bg-white py-16 sm:py-20">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <FaqAccordion
              items={faqItems}
              testId="faqs-accordion"
            />

            <div className="mt-12 rounded-xl border border-slate-200 bg-slate-50 p-6 text-center">
              <p className="text-sm text-slate-600">
                Still have questions? Write to us at{" "}
                <a
                  href={`mailto:${LEGAL.email}`}
                  className="font-semibold text-amber-600 hover:underline"
                >
                  {LEGAL.email}
                </a>
              </p>
            </div>
          </div>
        </section>

        <ClosingCTA />
      </div>
    </>
  );
}